import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "text-gray-400 mt-8 sx:w-full" }
const _hoisted_2 = { class: "h-auto md:py-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-full p-5" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-sm text-left font-normal pb-2 border-b-[1px] border-gray-800 text-white" }, " BOOK REVIEWS ")
], -1)
const _hoisted_4 = { class: "flex flex-col justify-center items-center mt-5" }
const _hoisted_5 = { class: "flex flex-col sx:w-4/5 sx:mx-auto md:w-3/4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-gray-400" }, " Search book reviews by book title & reader ", -1)
const _hoisted_7 = { class: "grid md:grid-cols-3 sx:grid-rows-3 gap-3 mt-6" }
const _hoisted_8 = { class: "flex flex-col max-w-sm shadow-lg bg-gray-400 backdrop-filter border-gray-200 rounded-3xl backdrop-blur-sm bg-opacity-10 text-left leading-6 p-5" }
const _hoisted_9 = {
  key: 0,
  class: "text-xs absolute backdrop-blur-md bg-black bg-opacity-10 p-3 left-[60px]"
}
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = { class: "text-xs cursor-pointer flex justify-between items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Bolu Babalola "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-[12px]" }, " @bolu_b")
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, " 64", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "italic text-xs mt-2" }, " \"Two weeks before his twenty-first birthday, Las Vegas native Bobby Ingersoll finds out he’s inherited a crushing gambling debt from his scumbag father.\"", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs mt-4" }, " Review On: Legendary magic duo Penn & Teller: a rollicking crime caper that will bend your mind like a spoon", -1)
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col max-w-sm shadow-lg bg-gray-400 backdrop-filter border-gray-200 rounded-3xl backdrop-blur-sm bg-opacity-10 text-left leading-6 p-5\"><div class=\"\"></div><div class=\"flex flex-col\"><span class=\"italic text-xs\">&quot;Two weeks before his twenty-first birthday, Las Vegas native Bobby Ingersoll finds out he’s inherited a crushing gambling debt from his scumbag father.&quot;</span><span class=\"text-xs mt-4\">Review On: Legendary magic duo Penn &amp; Teller: a rollicking crime caper that will bend your mind like a spoon</span></div></div><div class=\"flex flex-col max-w-sm bg-gray-400 backdrop-filter border-gray-200 rounded-3xl backdrop-blur-sm bg-opacity-10 text-left leading-6 p-5\"><div class=\"\"></div><div class=\"flex flex-col\"><span class=\"italic text-xs\">&quot;Two weeks before his twenty-first birthday, Las Vegas native Bobby Ingersoll finds out he’s inherited a crushing gambling debt from his scumbag father.&quot;</span><span class=\"text-xs mt-4\">Review On: Legendary magic duo Penn &amp; Teller: a rollicking crime caper that will bend your mind like a spoon</span></div></div>", 2)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("form", {
            class: "flex justify-center items-center mt-4",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.query) = $event)),
              placeholder: "e.g: Honey & Spice, Bolu Babalola, love",
              class: "w-full outline-none text-sm bg-gray-200 rounded-md border border-gray-400 p-2",
              onInput: _cache[1] || (_cache[1] = (...args) => (_ctx.clearOutput && _ctx.clearOutput(...args))),
              onKeyup: _cache[2] || (_cache[2] = (...args) => (_ctx.getSuggestions && _ctx.getSuggestions(...args)))
            }, null, 544), [
              [_vModelText, _ctx.query]
            ])
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            ($data.isMessageVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Your book recommendation will be based on the user's you follow. "))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "text-xs cursor-pointer inline-block relative",
                    onMouseover: _cache[4] || (_cache[4] = $event => ($options.showMessage())),
                    onMouseout: _cache[5] || (_cache[5] = $event => ($options.hideMessage())),
                    onClick: _cache[6] || (_cache[6] = $event => (_ctx.followReader()))
                  }, " Follow+ ", 32),
                  _hoisted_13
                ])
              ]),
              _hoisted_14,
              _hoisted_15
            ])
          ]),
          _hoisted_16
        ])
      ])
    ])
  ]))
}